import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './icon/iconfont.css'

// 如果您希望在此处导入 public.css 而不是在 public/index.html 中：
import '../public/css/swiper-bundle.min.css';
import '../public/css/public.css';
import './assets/less.less' // 导入您的 LESS 文件
import '../public/css/mobile-styles.css';
import "@/assets/responsive-fixes.less";

// 存储基准缩放级别 (100%)
let baseZoom = 1;

// 获取当前缩放级别
function getCurrentZoom() {
  // 从body的data属性获取当前zoom值
  const zoomValue = document.body.dataset.zoom;
  if (zoomValue) {
    return parseFloat(zoomValue);
  }

  // 默认zoom为baseZoom (100%)
  return baseZoom;
}

// 设置缩放级别，在55%到150%之间，并保持内容居中
function setZoomLevel(zoom) {
  // 限制zoom范围在0.55到1.5之间
  const newZoom = Math.min(Math.max(zoom, 0.55), 1.5);

  // 使用transform进行缩放并保持居中
  const appContentElement = document.getElementById('app-content');
  if (appContentElement) {
    appContentElement.style.transform = `scale(${newZoom})`;

    // 将当前zoom值存储在body的data属性中
    document.body.dataset.zoom = newZoom.toString();
  }

  return newZoom;
}

// 重置基准缩放级别为100%
function resetBaseZoom() {
  baseZoom = 1;
  setZoomLevel(1);
}

// 禁止Ctrl/Cmd+鼠标滚轮缩放，并限制范围
document.addEventListener('wheel', function(e) {
  if (e.ctrlKey || e.metaKey) {
    e.preventDefault();

    // 始终以基准缩放级别为基础进行调整
    let currentZoom = getCurrentZoom();

    // 根据滚轮方向调整缩放级别
    if (e.deltaY < 0) {
      // 向上滚动，放大
      currentZoom += 0.1;
    } else {
      // 向下滚动，缩小
      currentZoom -= 0.1;
    }

    // 设置新的缩放级别
    setZoomLevel(currentZoom);
  }
}, { passive: false });

// 禁止Ctrl/Cmd+加号/减号缩放，并限制范围
document.addEventListener('keydown', function(e) {
  // 检查是否按下了Ctrl键或Cmd键和加号/减号键
  if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=' || e.key === '_')) {
    e.preventDefault();

    // 始终以基准缩放级别为基础进行调整
    let currentZoom = getCurrentZoom();
    // 根据按键调整缩放级别
    if (e.key === '+' || e.key === '=') {
      // 放大
      currentZoom += 0.1;
    } else if (e.key === '-' || e.key === '_') {
      // 缩小
      currentZoom -= 0.1;
    }
    // 设置新的缩放级别
    setZoomLevel(currentZoom);
  }

  // 检查是否按下了Ctrl/Cmd+0 (恢复缩放)
  if ((e.ctrlKey || e.metaKey) && e.key === '0') {
    e.preventDefault();

    // 恢复到100%缩放
    resetBaseZoom();
  }
});

const app = createApp(App)
app.use(router)
app.mount('#app')